// eslint-disable-next-line no-use-before-define
import React, { useCallback, useState } from 'react';
import { AuxiliaryItemContainer } from './style';
import { SVGWrapper } from '../../../../svg-wrapper/svg-wrapper';
import { icons } from '@celebration/assets';
import { Links } from '../../links';
import isPathSelected from '../../../../../utils/is-path-selected';
export const SideMenuItemComponent = ({ menuItem, currentPath, navigate, }) => {
    let anyChildSelected = false;
    function checkAnyChildSelected(item) {
        if (item.children?.length) {
            item.children.forEach((cItem) => {
                checkAnyChildSelected(cItem);
            });
        }
        else {
            if (isPathSelected(item.path, currentPath)) {
                anyChildSelected = true;
            }
        }
    }
    checkAnyChildSelected(menuItem);
    const [open, setOpen] = useState(anyChildSelected);
    const isSelected = useCallback((path) => isPathSelected(path, currentPath), [currentPath]);
    const MenuList = ({ menuItems }) => {
        return menuItems.map((item) => (React.createElement(SideMenuItemComponent, { key: item.path, menuItem: item, navigate: navigate, currentPath: currentPath })));
    };
    if (menuItem.children.length) {
        return (React.createElement(AuxiliaryItemContainer, { className: `${open ? 'open' : ''}` },
            React.createElement("div", { className: `menu_item_title`, onClick: () => setOpen(!open) },
                React.createElement(SVGWrapper, { svg: icons.ChevronRight }),
                React.createElement("span", null, menuItem.title)),
            React.createElement("div", { className: "menu_item_content" },
                React.createElement(MenuList, { menuItems: menuItem.children }))));
    }
    return (React.createElement(AuxiliaryItemContainer, { onClick: () => navigate(menuItem.path), className: `${isSelected(menuItem.path) ? 'selected' : ''}` },
        React.createElement(Links, { link: menuItem, className: `menu_item_title menu_item_link` })));
};
//# sourceMappingURL=component.js.map